import { useRef } from 'react';

/**
 * This function can be used to count the amount of renders
 */
export const useRenders = (): number => {
    const rendersRef = useRef(0);
    rendersRef.current++;
    return rendersRef.current;
};
